import { environment, forbidApiKeyDomains, isProductionUrl } from '@env/environment';
import { COMPANIES_USER_EMAILS_LIST } from '@services/utils/global-config';
import { isDevelopmentDomain } from '@services/utils/get-current-domain';

export class ApiKeyHandler {
  static companyAccountList = COMPANIES_USER_EMAILS_LIST;

  static areRealMapsChecked() {
    const realMapStorage = localStorage.getItem('stageRealMap');
    return JSON.parse(realMapStorage) === true;
  }

  static isApiKeyNeeded() {
    return isProductionUrl || ApiKeyHandler.areRealMapsChecked();
  }

  static isCompaniesUser() {
    const emailStorage = localStorage.getItem('email');

    return this.companyAccountList.includes(emailStorage);
  }

  static isCompaniesWithApiKey() {
    return ApiKeyHandler.isApiKeyNeeded() && ApiKeyHandler.isCompaniesUser();
  }

  static getApiKey(isLocation = false) {
    if (forbidApiKeyDomains.includes(location.origin)) {
      return environment.defaultKey;
    }

    const isProduction = isProductionUrl && !isDevelopmentDomain() && !ApiKeyHandler.isCompaniesUser();
    const isDevWithRealMaps = isDevelopmentDomain() && ApiKeyHandler.areRealMapsChecked();
    if (isProduction || isDevWithRealMaps) {
      return environment.googleApiKey;
    }

    if (isLocation && ApiKeyHandler.isCompaniesWithApiKey()) {
      return environment.companiesApiKey;
    }

    return environment.defaultKey;
  }
}
